



















import {Component, Vue} from 'vue-property-decorator';

@Component({
    components: {},
})
export default class Footer extends Vue {
    public get paddingClass() {
        return {
            'pl-3': this.isXS(null),
            'pr-3': this.isXS(null),
            'pl-5': !this.isXS(null),
            'pr-5': !this.isXS(null),
        };
    }
}
